/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { EnumsBusinessType } from '../model/enumsBusinessType';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable({
    providedIn: 'root'
})
export class PricePerKmDeliveryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param userLat 
     * @param userLng 
     * @param cdStore 
     * @param nmBusinessType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPricePerKmDeliveryDeliveryPriceCalculatorGet(userLat?: number, userLng?: number, cdStore?: number, nmBusinessType?: EnumsBusinessType, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiPricePerKmDeliveryDeliveryPriceCalculatorGet(userLat?: number, userLng?: number, cdStore?: number, nmBusinessType?: EnumsBusinessType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiPricePerKmDeliveryDeliveryPriceCalculatorGet(userLat?: number, userLng?: number, cdStore?: number, nmBusinessType?: EnumsBusinessType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiPricePerKmDeliveryDeliveryPriceCalculatorGet(userLat?: number, userLng?: number, cdStore?: number, nmBusinessType?: EnumsBusinessType, observe: any = 'body', reportProgress: boolean = false): Observable<any> {





        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (userLat !== undefined && userLat !== null) {
            queryParameters = queryParameters.set('UserLat', <any>userLat);
        }
        if (userLng !== undefined && userLng !== null) {
            queryParameters = queryParameters.set('UserLng', <any>userLng);
        }
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('CdStore', <any>cdStore);
        }
        if (nmBusinessType !== undefined && nmBusinessType !== null) {
            queryParameters = queryParameters.set('NmBusinessType', <any>nmBusinessType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get', `${this.basePath}/api/PricePerKmDelivery/DeliveryPriceCalculator`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
